import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/a87364d7-8000-4267-b173-c11a1de910dc";
export const REGISTER_URL = "https://a.ntrk2.com/431aaec7-b945-4a3b-92bd-943aac6e1ebe";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://popcop.loadprkw2a.com/download?openExternalBrowser=1&id=0r0h0f4es5suavk";

export * from "./codes";
export * from "./context";
